export default __webpack_public_path__ + "static/yellow_tie-192ae023bdd366b9a7952caa33f92b6d.webp";